import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestDetails } from '../models/request/request.model';
import { Response } from '../models/common/response.model';

@Injectable({
  providedIn: 'root'
})
export class RequestService {

  private readonly baseURL = `${environment.apiUrl}/Request`;

  constructor(private readonly httpClient: HttpClient) { }

  getRequestDetails(): Observable<Response<RequestDetails[]>> {
    return this.httpClient.get<Response<RequestDetails[]>>(this.baseURL + '/current-user-assigned');
  }

  getAllRequestDetails(requestStatusId: number, userId: string ): Observable<Response<RequestDetails[]>> {
    return this.httpClient.get<Response<RequestDetails[]>>(this.baseURL + `/get-request-details/${requestStatusId}/${userId}`);
  }

  // createUserRequestDetails(): Observable<Response<RequestDetails[]>> {
  //   return this.httpClient.get<Response<RequestDetails[]>>(this.baseURL);
  // }
}
